import { useGetMembershipAffiliations } from "@queries/subscription-flow/useGetMembershipAffiliations";
import {
  MembershipAffiliationDto,
  MembershipAffiliationDtoAllowedLoginMethodsEnum,
} from "@shared/apis/sidekick/generated";

type UseLoginOptionsResult = {
  options: LoginOption[];
  isLoading: boolean;
};

export const useLoginOptions = (): UseLoginOptionsResult => {
  const { data: affiliations = [], isLoading } = useGetMembershipAffiliations();

  const options = affiliations
    .map(
      (affiliation: MembershipAffiliationDto): LoginOption => ({
        id: affiliation.id,
        name: affiliation.name,
        abbreviation: affiliation.abbreviation,
        allowedLoginMethods: affiliation.allowedLoginMethods,
      }),
    )
    .sort((a, b) => {
      if (a.id === "independent") return 1;
      if (b.id === "independent") return -1;
      return a.name.localeCompare(b.name);
    });

  return { options, isLoading };
};

export const getLoginOptionById = (
  options: LoginOption[],
  id: string | null,
): LoginOption | null => {
  if (!id) return null;
  return options.find((option) => option.id === id) || null;
};

export const isMlsSsoLoginOption = (option: {
  allowedLoginMethods: MembershipAffiliationDtoAllowedLoginMethodsEnum[];
}): boolean =>
  option.allowedLoginMethods.includes(
    MembershipAffiliationDtoAllowedLoginMethodsEnum.MlsSso,
  );

export const getLoginPathByOption = (option: LoginOption): string =>
  isMlsSsoLoginOption(option) ? "/login/sso" : "/login";

export type LoginOption = {
  id: string;
  name: string;
  abbreviation: string;
  allowedLoginMethods: MembershipAffiliationDtoAllowedLoginMethodsEnum[];
};

export const LOGIN_OPTION_STORAGE_KEY = "@sidekick:login-option";
